import { decimal, label, shortDate } from '@entities/ksp/format';
import { Tile, TileLabel, Tiles, TileSub, TileValue } from '../styles';
import { factActivity, finishStatus, nextMilestone, plural, progress, type PulseInput } from './pulse';

/** Четыре главные цифры проекта: сроки, выполнение, ближайшая веха, факт за неделю. */
export function PulseTiles({
  input,
  timezone,
  now,
}: {
  input: PulseInput;
  timezone: string;
  now: Date;
}) {
  const finish = finishStatus(input.summary);
  const done = progress(input.summary, label);
  const milestone = nextMilestone(input, now);
  const fact = factActivity(input, now);
  return (
    <Tiles>
      <Tile $tone={finish.tone}>
        <TileLabel>Сроки</TileLabel>
        <TileValue $tone={finish.tone}>{finish.value}</TileValue>
        <TileSub>
          {finish.forecast ? `Прогноз ${shortDate(finish.forecast, timezone)}` : 'Прогноза нет'}
          {finish.contract ? ` · договор ${shortDate(finish.contract, timezone)}` : ''}
        </TileSub>
      </Tile>
      <Tile>
        <TileLabel>Выполнено</TileLabel>
        <TileValue $tone={done.value == null ? 'neutral' : undefined}>
          {done.value == null ? '— %' : decimal(done.value, ' %')}
        </TileValue>
        <TileSub>
          {done.value != null
            ? `план ${decimal(done.plan, ' %')} · отклонение ${decimal(done.delta, ' п.п.')}`
            : (done.reason ?? 'расчёта нет')}
        </TileSub>
      </Tile>
      <Tile>
        <TileLabel>
          {milestone?.kind === 'contract' ? 'Ближайшая договорная веха' : 'Ближайшая веха графика'}
        </TileLabel>
        <TileValue>{milestone ? shortDate(milestone.date, timezone) : '—'}</TileValue>
        <TileSub title={milestone?.title}>{milestone ? milestone.title : 'вех впереди нет'}</TileSub>
      </Tile>
      <Tile $tone={fact.pending ? 'warn' : undefined}>
        <TileLabel>Факт за неделю</TileLabel>
        <TileValue>{fact.week}</TileValue>
        <TileSub>
          {fact.pending
            ? `${fact.pending} ${plural(fact.pending, 'ждёт', 'ждут', 'ждут')} приёмки`
            : fact.week
              ? plural(fact.week, 'запись выполнения', 'записи выполнения', 'записей выполнения')
              : 'рапортов не было'}
        </TileSub>
      </Tile>
    </Tiles>
  );
}
